//
// Copyright 2021 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/config.proto (package dxos.config, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any, FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any, file_google_protobuf_descriptor, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/config.proto.
 */
export const file_dxos_config: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_any, file_google_protobuf_struct, file_google_protobuf_descriptor]);

/**
 * @generated from message dxos.config.Config
 */
export type Config = Message<"dxos.config.Config"> & {
  /**
   * @generated from field: optional int32 version = 1;
   */
  version?: number;

  /**
   * @generated from field: optional dxos.config.Package package = 2;
   */
  package?: Package;

  /**
   * @generated from field: optional dxos.config.Runtime runtime = 3;
   */
  runtime?: Runtime;
};

/**
 * Describes the message dxos.config.Config.
 * Use `create(ConfigSchema)` to create a new message.
 */
export const ConfigSchema: GenMessage<Config> = /*@__PURE__*/
  messageDesc(file_dxos_config, 0);

/**
 * @generated from message dxos.config.Package
 */
export type Package = Message<"dxos.config.Package"> & {
  /**
   * @generated from field: optional string license = 1;
   */
  license?: string;

  /**
   * @generated from field: repeated dxos.config.Repo repos = 2;
   */
  repos: Repo[];

  /**
   * @generated from field: repeated dxos.config.Module modules = 3;
   */
  modules: Module[];
};

/**
 * Describes the message dxos.config.Package.
 * Use `create(PackageSchema)` to create a new message.
 */
export const PackageSchema: GenMessage<Package> = /*@__PURE__*/
  messageDesc(file_dxos_config, 1);

/**
 * TODO(wittjosiah): Shared with registry types. Factor out?
 *
 * @generated from message dxos.config.Repo
 */
export type Repo = Message<"dxos.config.Repo"> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string url = 2;
   */
  url?: string;

  /**
   * @generated from field: optional string version = 3;
   */
  version?: string;
};

/**
 * Describes the message dxos.config.Repo.
 * Use `create(RepoSchema)` to create a new message.
 */
export const RepoSchema: GenMessage<Repo> = /*@__PURE__*/
  messageDesc(file_dxos_config, 2);

/**
 *
 * Unit of deployment.
 *
 *
 * @generated from message dxos.config.Module
 */
export type Module = Message<"dxos.config.Module"> & {
  /**
   * TODO(burdon): Ensured FQ (e.g., 'dxos.app.xxx')
   *
   * @generated from field: optional string id = 8;
   */
  id?: string;

  /**
   * TODO(burdon): Replace with id (or key?)
   *
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * TODO(burdon): Define namespace (e.g.,
   *
   * @generated from field: optional string type = 2;
   */
  type?: string;

  /**
   * TODO(burdon): Start at 10.
   *
   * @generated from field: optional string display_name = 3;
   */
  displayName?: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: repeated string tags = 5;
   */
  tags: string[];

  /**
   * TODO(burdon): ???
   *
   * @generated from field: optional bytes bundle = 6;
   */
  bundle?: Uint8Array;

  /**
   * TODO(burdon): Remove.
   *
   * @generated from field: optional bool tunnel = 7;
   */
  tunnel?: boolean;

  /**
   * TODO(burdon): Start at 100.
   *
   * TODO(burdon): E.g., types.
   *
   * @generated from field: repeated dxos.config.Module deps = 10;
   */
  deps: Module[];

  /**
   * @generated from field: optional dxos.config.Module.Build build = 100;
   */
  build?: Module_Build;

  /**
   * @generated from field: repeated dxos.config.Repo repos = 101;
   */
  repos: Repo[];

  /**
   * / Data which will be included as apart of DXNS record.
   * / The data will be validated based on the type when being published.
   *
   * @generated from field: optional google.protobuf.Any record = 200;
   */
  record?: Any;
};

/**
 * Describes the message dxos.config.Module.
 * Use `create(ModuleSchema)` to create a new message.
 */
export const ModuleSchema: GenMessage<Module> = /*@__PURE__*/
  messageDesc(file_dxos_config, 3);

/**
 * @generated from message dxos.config.Module.Build
 */
export type Module_Build = Message<"dxos.config.Module.Build"> & {
  /**
   * @generated from field: optional string command = 1;
   */
  command?: string;

  /**
   * @generated from field: optional string outdir = 2;
   */
  outdir?: string;

  /**
   * @generated from field: optional string version = 3;
   */
  version?: string;

  /**
   * @generated from field: optional string tag = 4;
   */
  tag?: string;

  /**
   * @generated from field: optional google.protobuf.Struct env = 10;
   */
  env?: JsonObject;
};

/**
 * Describes the message dxos.config.Module.Build.
 * Use `create(Module_BuildSchema)` to create a new message.
 */
export const Module_BuildSchema: GenMessage<Module_Build> = /*@__PURE__*/
  messageDesc(file_dxos_config, 3, 0);

/**
 * @generated from message dxos.config.Runtime
 */
export type Runtime = Message<"dxos.config.Runtime"> & {
  /**
   * @generated from field: optional dxos.config.Runtime.Client client = 1;
   */
  client?: Runtime_Client;

  /**
   * @generated from field: optional dxos.config.Runtime.App app = 2;
   */
  app?: Runtime_App;

  /**
   * @generated from field: optional dxos.config.Runtime.CLI cli = 3;
   */
  cli?: Runtime_CLI;

  /**
   * @generated from field: optional dxos.config.Runtime.Props props = 4;
   */
  props?: Runtime_Props;

  /**
   * @generated from field: optional dxos.config.Runtime.Services services = 5;
   */
  services?: Runtime_Services;

  /**
   * @generated from field: optional dxos.config.Runtime.System system = 6;
   */
  system?: Runtime_System;

  /**
   * @generated from field: optional dxos.config.Runtime.Kube kube = 7;
   */
  kube?: Runtime_Kube;

  /**
   * @generated from field: repeated dxos.config.Runtime.Keys keys = 8;
   */
  keys: Runtime_Keys[];

  /**
   * @generated from field: optional dxos.config.Runtime.Agent agent = 9;
   */
  agent?: Runtime_Agent;
};

/**
 * Describes the message dxos.config.Runtime.
 * Use `create(RuntimeSchema)` to create a new message.
 */
export const RuntimeSchema: GenMessage<Runtime> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4);

/**
 * @generated from message dxos.config.Runtime.Client
 */
export type Runtime_Client = Message<"dxos.config.Runtime.Client"> & {
  /**
   * @generated from field: optional dxos.config.Runtime.Client.Log log = 1;
   */
  log?: Runtime_Client_Log;

  /**
   * @generated from field: optional dxos.config.Runtime.Client.Storage storage = 2;
   */
  storage?: Runtime_Client_Storage;

  /**
   * * Deprecated: no runtime readers (test/story stubs only). 
   *
   * @generated from field: optional bool enable_snapshots = 3 [deprecated = true];
   * @deprecated
   */
  enableSnapshots?: boolean;

  /**
   * * Deprecated: no runtime readers (test/story stubs only). 
   *
   * @generated from field: optional int32 snapshot_interval = 4 [deprecated = true];
   * @deprecated
   */
  snapshotInterval?: number;

  /**
   * / Milliseconds
   *
   * @generated from field: optional int32 invitation_expiration = 5;
   */
  invitationExpiration?: number;

  /**
   * / Location of the remote client host.
   * TODO(burdon): Rename vault_endpoint (generalize http/ws; drop
   * vault.html).
   *
   * @generated from field: optional string remote_source = 6;
   */
  remoteSource?: string;

  /**
   * Authenticate via `Sec-WebSocket-Protocol` header hack.
   *
   * @generated from field: optional string remote_source_authentication_token = 8;
   */
  remoteSourceAuthenticationToken?: string;

  /**
   * / Connect to and serve client services to a remote proxy.
   *
   * @generated from field: optional string devtools_proxy = 7;
   */
  devtoolsProxy?: string;

  /**
   * / Spaces will stay in SpaceState.CLOSED until explicitly opened. Speeds up
   * / client-services initialization.
   *
   * @generated from field: optional bool lazy_space_open = 9;
   */
  lazySpaceOpen?: boolean;

  /**
   * / Disabled automerge & hypercore replication through P2P connections.
   *
   * @generated from field: optional bool disable_p2p_replication = 10;
   */
  disableP2pReplication?: boolean;

  /**
   * @generated from field: optional bool enable_vector_indexing = 12;
   */
  enableVectorIndexing?: boolean;

  /**
   * @generated from field: optional dxos.config.Runtime.Client.EdgeFeatures edge_features = 11;
   */
  edgeFeatures?: Runtime_Client_EdgeFeatures;

  /**
   * / Observability group attached as metadata to signaling requests.
   * / NOTE: When running through a shared worker, subsequent client connections can refresh this
   * / value (last-writer-wins); the first client still determines the worker's other config.
   *
   * @generated from field: optional string observability_group = 13;
   */
  observabilityGroup?: string;

  /**
   * / Enable telemetry metadata attached to signaling requests.
   * / NOTE: When running through a shared worker, subsequent client connections can refresh this
   * / value (last-writer-wins); the first client still determines the worker's other config.
   *
   * @generated from field: optional bool signal_telemetry_enabled = 14;
   */
  signalTelemetryEnabled?: boolean;

  /**
   * / Use in-process (single-client) coordinator for dedicated-worker mode.
   * / Bypasses SharedWorker; used for WKWebView where the coordinator SharedWorker port is unreliable.
   *
   * @generated from field: optional bool single_client_mode = 15;
   */
  singleClientMode?: boolean;

  /**
   * / Deployment mode for client services. Read by `createClientServices` to select between
   * / in-process (HOST), SharedWorker, and dedicated Worker runtimes. Required when no
   * / `remote_source` is configured.
   *
   * @generated from field: optional dxos.config.Runtime.Client.ServicesMode services_mode = 16;
   */
  servicesMode?: Runtime_Client_ServicesMode;

  /**
   * / Anchor spaces on an automerge space root document and carry credentials in a credentials
   * / document, instead of deriving the space id from the space key and reading credentials from
   * / the hypercore control feed. Off by default: the automerge scheme is opt-in until it has
   * / soaked. Set via DX_AUTOMERGE_CREDENTIALS.
   *
   * @generated from field: optional bool automerge_credentials = 17;
   */
  automergeCredentials?: boolean;

  /**
   * / Query evaluation path; defaults to SQL. Set MEMORY to evaluate in JS instead, which is how a
   * / suspected regression is bisected against the pre-compiler path. `DX_ECHO_QUERY_EXECUTOR`
   * / overrides it when unset.
   *
   * @generated from field: optional dxos.config.Runtime.Client.QueryExecutor query_executor = 18;
   */
  queryExecutor?: Runtime_Client_QueryExecutor;
};

/**
 * Describes the message dxos.config.Runtime.Client.
 * Use `create(Runtime_ClientSchema)` to create a new message.
 */
export const Runtime_ClientSchema: GenMessage<Runtime_Client> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 0);

/**
 * @generated from message dxos.config.Runtime.Client.Storage
 */
export type Runtime_Client_Storage = Message<"dxos.config.Runtime.Client.Storage"> & {
  /**
   * @generated from field: optional bool persistent = 1;
   */
  persistent?: boolean;

  /**
   * @generated from field: optional dxos.config.Runtime.Client.Storage.StorageDriver key_store = 2;
   */
  keyStore?: Runtime_Client_Storage_StorageDriver;

  /**
   * @generated from field: optional dxos.config.Runtime.Client.Storage.StorageDriver data_store = 3;
   */
  dataStore?: Runtime_Client_Storage_StorageDriver;

  /**
   * @generated from field: optional string data_root = 4;
   */
  dataRoot?: string;

  /**
   * *
   * @deprecated
   *
   * @generated from field: optional bool space_fragmentation = 5;
   */
  spaceFragmentation?: boolean;

  /**
   * / Backing store for SQLite runtimes. Defaults to MEMORY when unset.
   *
   * @generated from field: optional dxos.config.Runtime.Client.Storage.SqliteMode sqlite_mode = 6;
   */
  sqliteMode?: Runtime_Client_Storage_SqliteMode;
};

/**
 * Describes the message dxos.config.Runtime.Client.Storage.
 * Use `create(Runtime_Client_StorageSchema)` to create a new message.
 */
export const Runtime_Client_StorageSchema: GenMessage<Runtime_Client_Storage> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 0, 0);

/**
 * @generated from enum dxos.config.Runtime.Client.Storage.StorageDriver
 */
export enum Runtime_Client_Storage_StorageDriver {
  /**
   * @generated from enum value: RAM = 0;
   */
  RAM = 0,

  /**
   * @generated from enum value: IDB = 1;
   */
  IDB = 1,

  /**
   * @generated from enum value: CHROME = 2;
   */
  CHROME = 2,

  /**
   * @generated from enum value: FIREFOX = 3;
   */
  FIREFOX = 3,

  /**
   * @generated from enum value: NODE = 4;
   */
  NODE = 4,

  /**
   * @generated from enum value: WEBFS = 5;
   */
  WEBFS = 5,

  /**
   * Key storage only.
   *
   * @generated from enum value: LEVELJS = 11;
   */
  LEVELJS = 11,

  /**
   * @generated from enum value: JSONDOWN = 12;
   */
  JSONDOWN = 12,
}

/**
 * Describes the enum dxos.config.Runtime.Client.Storage.StorageDriver.
 */
export const Runtime_Client_Storage_StorageDriverSchema: GenEnum<Runtime_Client_Storage_StorageDriver> = /*@__PURE__*/
  enumDesc(file_dxos_config, 4, 0, 0, 0);

/**
 * / Storage backing for SQLite (indexes & persistent state). The caller must supply the
 * / matching worker factory / path — `createClientServices` does not pick a mode from the
 * / presence of options.
 *
 * @generated from enum dxos.config.Runtime.Client.Storage.SqliteMode
 */
export enum Runtime_Client_Storage_SqliteMode {
  /**
   * @generated from enum value: UNSPECIFIED_SQLITE_MODE = 0;
   */
  UNSPECIFIED_SQLITE_MODE = 0,

  /**
   * / Ephemeral in-memory SQLite. Indexes are rebuilt on each start.
   *
   * @generated from enum value: MEMORY = 1;
   */
  MEMORY = 1,

  /**
   * / OPFS-backed SQLite running in a dedicated worker (browser).
   * / Requires `createOpfsWorker` to be passed to `createClientServices`.
   *
   * @generated from enum value: OPFS = 2;
   */
  OPFS = 2,

  /**
   * / File-backed SQLite (Node/Bun). Uses `data_root` to locate the database file.
   *
   * @generated from enum value: FILE = 3;
   */
  FILE = 3,
}

/**
 * Describes the enum dxos.config.Runtime.Client.Storage.SqliteMode.
 */
export const Runtime_Client_Storage_SqliteModeSchema: GenEnum<Runtime_Client_Storage_SqliteMode> = /*@__PURE__*/
  enumDesc(file_dxos_config, 4, 0, 0, 1);

/**
 * @generated from message dxos.config.Runtime.Client.Log
 */
export type Runtime_Client_Log = Message<"dxos.config.Runtime.Client.Log"> & {
  /**
   * @generated from field: optional string filter = 1;
   */
  filter?: string;

  /**
   * @generated from field: optional string prefix = 2;
   */
  prefix?: string;
};

/**
 * Describes the message dxos.config.Runtime.Client.Log.
 * Use `create(Runtime_Client_LogSchema)` to create a new message.
 */
export const Runtime_Client_LogSchema: GenMessage<Runtime_Client_Log> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 0, 1);

/**
 * @generated from message dxos.config.Runtime.Client.EdgeFeatures
 */
export type Runtime_Client_EdgeFeatures = Message<"dxos.config.Runtime.Client.EdgeFeatures"> & {
  /**
   * @generated from field: optional bool feed_replicator = 1;
   */
  feedReplicator?: boolean;

  /**
   * / Enables Subduction sedimentree transport for Automerge document replication.
   *
   * @generated from field: optional bool subduction_replicator = 5;
   */
  subductionReplicator?: boolean;

  /**
   * @generated from field: optional bool signaling = 3;
   */
  signaling?: boolean;

  /**
   * @generated from field: optional bool agents = 4;
   */
  agents?: boolean;
};

/**
 * Describes the message dxos.config.Runtime.Client.EdgeFeatures.
 * Use `create(Runtime_Client_EdgeFeaturesSchema)` to create a new message.
 */
export const Runtime_Client_EdgeFeaturesSchema: GenMessage<Runtime_Client_EdgeFeatures> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 0, 2);

/**
 * / Where client services run. Drives `createClientServices` routing.
 *
 * @generated from enum dxos.config.Runtime.Client.ServicesMode
 */
export enum Runtime_Client_ServicesMode {
  /**
   * @generated from enum value: UNSPECIFIED_SERVICES_MODE = 0;
   */
  UNSPECIFIED_SERVICES_MODE = 0,

  /**
   * / Run services in the same thread as the client.
   *
   * @generated from enum value: HOST = 1;
   */
  HOST = 1,

  /**
   * / @deprecated Removed in favour of DEDICATED_WORKER. Value reserved for wire compatibility.
   *
   * @generated from enum value: SHARED_WORKER = 2;
   */
  SHARED_WORKER = 2,

  /**
   * / Run services in a dedicated Worker elected via a lock (leader/follower).
   *
   * @generated from enum value: DEDICATED_WORKER = 3;
   */
  DEDICATED_WORKER = 3,
}

/**
 * Describes the enum dxos.config.Runtime.Client.ServicesMode.
 */
export const Runtime_Client_ServicesModeSchema: GenEnum<Runtime_Client_ServicesMode> = /*@__PURE__*/
  enumDesc(file_dxos_config, 4, 0, 0);

/**
 * / Which path evaluates ECHO queries on the host.
 *
 * @generated from enum dxos.config.Runtime.Client.QueryExecutor
 */
export enum Runtime_Client_QueryExecutor {
  /**
   * @generated from enum value: UNSPECIFIED_QUERY_EXECUTOR = 0;
   */
  UNSPECIFIED_QUERY_EXECUTOR = 0,

  /**
   * / Load the objects a plan touches and evaluate every step in JS.
   *
   * @generated from enum value: MEMORY = 1;
   */
  MEMORY = 1,

  /**
   * / Compile the plan into one SQLite statement over the index tables and load no documents.
   * / The default.
   *
   * @generated from enum value: SQL = 2;
   */
  SQL = 2,
}

/**
 * Describes the enum dxos.config.Runtime.Client.QueryExecutor.
 */
export const Runtime_Client_QueryExecutorSchema: GenEnum<Runtime_Client_QueryExecutor> = /*@__PURE__*/
  enumDesc(file_dxos_config, 4, 0, 1);

/**
 * @generated from message dxos.config.Runtime.App
 */
export type Runtime_App = Message<"dxos.config.Runtime.App"> & {
  /**
   * @generated from field: optional string org = 1;
   */
  org?: string;

  /**
   * @generated from field: optional string theme = 2;
   */
  theme?: string;

  /**
   * @generated from field: optional string website = 3;
   */
  website?: string;

  /**
   * @generated from field: optional string public_url = 4;
   */
  publicUrl?: string;

  /**
   * @generated from field: optional dxos.config.Runtime.App.BuildInfo build = 100;
   */
  build?: Runtime_App_BuildInfo;

  /**
   * @generated from field: optional google.protobuf.Struct env = 101;
   */
  env?: JsonObject;
};

/**
 * Describes the message dxos.config.Runtime.App.
 * Use `create(Runtime_AppSchema)` to create a new message.
 */
export const Runtime_AppSchema: GenMessage<Runtime_App> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 1);

/**
 * @generated from message dxos.config.Runtime.App.BuildInfo
 */
export type Runtime_App_BuildInfo = Message<"dxos.config.Runtime.App.BuildInfo"> & {
  /**
   * / RFC-3339 datetime string.
   *
   * @generated from field: optional string timestamp = 1;
   */
  timestamp?: string;

  /**
   * @generated from field: optional string commit_hash = 2;
   */
  commitHash?: string;

  /**
   * / Version from package.json.
   *
   * @generated from field: optional string version = 3;
   */
  version?: string;

  /**
   * @generated from field: optional string branch = 4;
   */
  branch?: string;
};

/**
 * Describes the message dxos.config.Runtime.App.BuildInfo.
 * Use `create(Runtime_App_BuildInfoSchema)` to create a new message.
 */
export const Runtime_App_BuildInfoSchema: GenMessage<Runtime_App_BuildInfo> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 1, 0);

/**
 * @generated from message dxos.config.Runtime.Agent
 */
export type Runtime_Agent = Message<"dxos.config.Runtime.Agent"> & {
  /**
   * @generated from field: repeated dxos.config.Runtime.Agent.Plugin plugins = 1;
   */
  plugins: Runtime_Agent_Plugin[];
};

/**
 * Describes the message dxos.config.Runtime.Agent.
 * Use `create(Runtime_AgentSchema)` to create a new message.
 */
export const Runtime_AgentSchema: GenMessage<Runtime_Agent> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 2);

/**
 * @generated from message dxos.config.Runtime.Agent.Plugin
 */
export type Runtime_Agent_Plugin = Message<"dxos.config.Runtime.Agent.Plugin"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional bool enabled = 3;
   */
  enabled?: boolean;

  /**
   * @generated from field: optional google.protobuf.Any config = 10;
   */
  config?: Any;
};

/**
 * Describes the message dxos.config.Runtime.Agent.Plugin.
 * Use `create(Runtime_Agent_PluginSchema)` to create a new message.
 */
export const Runtime_Agent_PluginSchema: GenMessage<Runtime_Agent_Plugin> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 2, 0);

/**
 * CLI configuration
 *
 * @generated from message dxos.config.Runtime.CLI
 */
export type Runtime_CLI = Message<"dxos.config.Runtime.CLI"> & {
  /**
   * @generated from field: optional string node_path = 1;
   */
  nodePath?: string;

  /**
   * @generated from field: optional dxos.config.Runtime.CLI.AppServe app = 2;
   */
  app?: Runtime_CLI_AppServe;

  /**
   * @generated from field: optional dxos.config.Runtime.CLI.Package console = 3;
   */
  console?: Runtime_CLI_Package;

  /**
   * @generated from field: optional dxos.config.Runtime.CLI.Package mdns = 4;
   */
  mdns?: Runtime_CLI_Package;

  /**
   * @generated from field: optional dxos.config.Runtime.CLI.Package signal = 5;
   */
  signal?: Runtime_CLI_Package;

  /**
   * @generated from field: optional string npm_client = 6;
   */
  npmClient?: string;

  /**
   * @generated from field: optional string channel = 7;
   */
  channel?: string;
};

/**
 * Describes the message dxos.config.Runtime.CLI.
 * Use `create(Runtime_CLISchema)` to create a new message.
 */
export const Runtime_CLISchema: GenMessage<Runtime_CLI> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 3);

/**
 * @generated from message dxos.config.Runtime.CLI.AppServe
 */
export type Runtime_CLI_AppServe = Message<"dxos.config.Runtime.CLI.AppServe"> & {
  /**
   * @generated from field: optional dxos.config.Runtime.CLI.AppServe.Serve serve = 1;
   */
  serve?: Runtime_CLI_AppServe_Serve;
};

/**
 * Describes the message dxos.config.Runtime.CLI.AppServe.
 * Use `create(Runtime_CLI_AppServeSchema)` to create a new message.
 */
export const Runtime_CLI_AppServeSchema: GenMessage<Runtime_CLI_AppServe> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 3, 0);

/**
 * @generated from message dxos.config.Runtime.CLI.AppServe.Serve
 */
export type Runtime_CLI_AppServe_Serve = Message<"dxos.config.Runtime.CLI.AppServe.Serve"> & {
  /**
   * @generated from field: optional string config = 1;
   */
  config?: string;

  /**
   * @generated from field: optional string login_app = 2;
   */
  loginApp?: string;

  /**
   * @generated from field: optional string key_phrase = 3;
   */
  keyPhrase?: string;
};

/**
 * Describes the message dxos.config.Runtime.CLI.AppServe.Serve.
 * Use `create(Runtime_CLI_AppServe_ServeSchema)` to create a new message.
 */
export const Runtime_CLI_AppServe_ServeSchema: GenMessage<Runtime_CLI_AppServe_Serve> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 3, 0, 0);

/**
 * @generated from message dxos.config.Runtime.CLI.Package
 */
export type Runtime_CLI_Package = Message<"dxos.config.Runtime.CLI.Package"> & {
  /**
   * @generated from field: optional string package = 1;
   */
  package?: string;

  /**
   * @generated from field: optional string channel = 2;
   */
  channel?: string;

  /**
   * @generated from field: optional string bin = 3;
   */
  bin?: string;

  /**
   * @generated from field: optional string config = 4;
   */
  config?: string;
};

/**
 * Describes the message dxos.config.Runtime.CLI.Package.
 * Use `create(Runtime_CLI_PackageSchema)` to create a new message.
 */
export const Runtime_CLI_PackageSchema: GenMessage<Runtime_CLI_Package> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 3, 1);

/**
 * @generated from message dxos.config.Runtime.Props
 */
export type Runtime_Props = Message<"dxos.config.Runtime.Props"> & {
  /**
   * @generated from field: optional string title = 1;
   */
  title?: string;
};

/**
 * Describes the message dxos.config.Runtime.Props.
 * Use `create(Runtime_PropsSchema)` to create a new message.
 */
export const Runtime_PropsSchema: GenMessage<Runtime_Props> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 4);

/**
 * @generated from message dxos.config.Runtime.System
 */
export type Runtime_System = Message<"dxos.config.Runtime.System"> & {
  /**
   * @generated from field: optional string debug = 1;
   */
  debug?: string;
};

/**
 * Describes the message dxos.config.Runtime.System.
 * Use `create(Runtime_SystemSchema)` to create a new message.
 */
export const Runtime_SystemSchema: GenMessage<Runtime_System> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 5);

/**
 *
 * KUBE
 *
 *
 * @generated from message dxos.config.Runtime.Kube
 */
export type Runtime_Kube = Message<"dxos.config.Runtime.Kube"> & {
  /**
   * TODO(burdon): Needs documentation/
   *
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * @generated from field: string port = 2;
   */
  port: string;

  /**
   * @generated from field: dxos.config.Runtime.Kube.Autoupdate autoupdate = 3;
   */
  autoupdate?: Runtime_Kube_Autoupdate;

  /**
   * @generated from field: dxos.config.Runtime.Kube.Https https = 4;
   */
  https?: Runtime_Kube_Https;

  /**
   * @generated from field: dxos.config.Runtime.Kube.P2P p2p = 5;
   */
  p2p?: Runtime_Kube_P2P;

  /**
   * TODO(burdon): ?
   *
   * @generated from field: string confhost = 6;
   */
  confhost: string;

  /**
   * @generated from field: repeated string env = 7;
   */
  env: string[];

  /**
   * @generated from field: repeated string alias = 8;
   */
  alias: string[];

  /**
   * @generated from field: dxos.config.Runtime.Kube.Monitoring monitoring = 9;
   */
  monitoring?: Runtime_Kube_Monitoring;

  /**
   * @generated from field: dxos.config.Runtime.Kube.Trace trace = 10;
   */
  trace?: Runtime_Kube_Trace;

  /**
   * @generated from field: dxos.config.Runtime.Kube.Telemetry telemetry = 11;
   */
  telemetry?: Runtime_Kube_Telemetry;

  /**
   * @generated from field: dxos.config.Runtime.Kube.Gravity gravity = 12;
   */
  gravity?: Runtime_Kube_Gravity;

  /**
   * @generated from field: dxos.config.Runtime.Kube.AppTunneling app_tunneling = 13;
   */
  appTunneling?: Runtime_Kube_AppTunneling;

  /**
   * @generated from field: dxos.config.Runtime.Kube.Bots bots = 14;
   */
  bots?: Runtime_Kube_Bots;

  /**
   * TODO(nf): manage secret better.
   *
   * @generated from field: repeated dxos.config.Runtime.Kube.KuboApiAuthorization ipfs_api_authorizations = 15;
   */
  ipfsApiAuthorizations: Runtime_Kube_KuboApiAuthorization[];
};

/**
 * Describes the message dxos.config.Runtime.Kube.
 * Use `create(Runtime_KubeSchema)` to create a new message.
 */
export const Runtime_KubeSchema: GenMessage<Runtime_Kube> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6);

/**
 * @generated from message dxos.config.Runtime.Kube.Autoupdate
 */
export type Runtime_Kube_Autoupdate = Message<"dxos.config.Runtime.Kube.Autoupdate"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * / Seconds
   *
   * @generated from field: int32 interval = 2;
   */
  interval: number;
};

/**
 * Describes the message dxos.config.Runtime.Kube.Autoupdate.
 * Use `create(Runtime_Kube_AutoupdateSchema)` to create a new message.
 */
export const Runtime_Kube_AutoupdateSchema: GenMessage<Runtime_Kube_Autoupdate> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6, 0);

/**
 * @generated from message dxos.config.Runtime.Kube.Https
 */
export type Runtime_Kube_Https = Message<"dxos.config.Runtime.Kube.Https"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string port = 2;
   */
  port: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string certfile = 4;
   */
  certfile: string;

  /**
   * @generated from field: string keyfile = 5;
   */
  keyfile: string;

  /**
   * TODO(burdon): dns_provider.
   *
   * @generated from field: string dnsprovider = 6;
   */
  dnsprovider: string;
};

/**
 * Describes the message dxos.config.Runtime.Kube.Https.
 * Use `create(Runtime_Kube_HttpsSchema)` to create a new message.
 */
export const Runtime_Kube_HttpsSchema: GenMessage<Runtime_Kube_Https> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6, 1);

/**
 * @generated from message dxos.config.Runtime.Kube.P2P
 */
export type Runtime_Kube_P2P = Message<"dxos.config.Runtime.Kube.P2P"> & {
  /**
   * TODO(egorgripasov): private_key
   *
   * @generated from field: string privatekey = 1;
   */
  privatekey: string;

  /**
   * @generated from field: string port = 2;
   */
  port: string;

  /**
   * @generated from field: repeated string bootstrap = 3;
   */
  bootstrap: string[];
};

/**
 * Describes the message dxos.config.Runtime.Kube.P2P.
 * Use `create(Runtime_Kube_P2PSchema)` to create a new message.
 */
export const Runtime_Kube_P2PSchema: GenMessage<Runtime_Kube_P2P> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6, 2);

/**
 * @generated from message dxos.config.Runtime.Kube.Monitoring
 */
export type Runtime_Kube_Monitoring = Message<"dxos.config.Runtime.Kube.Monitoring"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string endpoint = 2;
   */
  endpoint: string;

  /**
   * / Seconds
   *
   * @generated from field: int32 interval = 3;
   */
  interval: number;
};

/**
 * Describes the message dxos.config.Runtime.Kube.Monitoring.
 * Use `create(Runtime_Kube_MonitoringSchema)` to create a new message.
 */
export const Runtime_Kube_MonitoringSchema: GenMessage<Runtime_Kube_Monitoring> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6, 3);

/**
 * @generated from message dxos.config.Runtime.Kube.Trace
 */
export type Runtime_Kube_Trace = Message<"dxos.config.Runtime.Kube.Trace"> & {
  /**
   * @generated from field: bool disabled = 1;
   */
  disabled: boolean;
};

/**
 * Describes the message dxos.config.Runtime.Kube.Trace.
 * Use `create(Runtime_Kube_TraceSchema)` to create a new message.
 */
export const Runtime_Kube_TraceSchema: GenMessage<Runtime_Kube_Trace> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6, 4);

/**
 * @generated from message dxos.config.Runtime.Kube.Telemetry
 */
export type Runtime_Kube_Telemetry = Message<"dxos.config.Runtime.Kube.Telemetry"> & {
  /**
   * @generated from field: bool disabled = 1;
   */
  disabled: boolean;

  /**
   * @generated from field: repeated string tags = 2;
   */
  tags: string[];
};

/**
 * Describes the message dxos.config.Runtime.Kube.Telemetry.
 * Use `create(Runtime_Kube_TelemetrySchema)` to create a new message.
 */
export const Runtime_Kube_TelemetrySchema: GenMessage<Runtime_Kube_Telemetry> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6, 5);

/**
 * @generated from message dxos.config.Runtime.Kube.Gravity
 */
export type Runtime_Kube_Gravity = Message<"dxos.config.Runtime.Kube.Gravity"> & {
  /**
   * @generated from field: bool disabled = 1;
   */
  disabled: boolean;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string log_dir = 3;
   */
  logDir?: string;
};

/**
 * Describes the message dxos.config.Runtime.Kube.Gravity.
 * Use `create(Runtime_Kube_GravitySchema)` to create a new message.
 */
export const Runtime_Kube_GravitySchema: GenMessage<Runtime_Kube_Gravity> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6, 6);

/**
 * @generated from message dxos.config.Runtime.Kube.AppTunneling
 */
export type Runtime_Kube_AppTunneling = Message<"dxos.config.Runtime.Kube.AppTunneling"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string command_template = 2;
   */
  commandTemplate: string;

  /**
   * @generated from field: string output_re = 3;
   */
  outputRe: string;

  /**
   * @generated from field: string port = 4;
   */
  port: string;
};

/**
 * Describes the message dxos.config.Runtime.Kube.AppTunneling.
 * Use `create(Runtime_Kube_AppTunnelingSchema)` to create a new message.
 */
export const Runtime_Kube_AppTunnelingSchema: GenMessage<Runtime_Kube_AppTunneling> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6, 7);

/**
 * @generated from message dxos.config.Runtime.Kube.Bots
 */
export type Runtime_Kube_Bots = Message<"dxos.config.Runtime.Kube.Bots"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * / Refresh interval - Seconds
   *
   * @generated from field: int32 interval = 2;
   */
  interval: number;
};

/**
 * Describes the message dxos.config.Runtime.Kube.Bots.
 * Use `create(Runtime_Kube_BotsSchema)` to create a new message.
 */
export const Runtime_Kube_BotsSchema: GenMessage<Runtime_Kube_Bots> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6, 8);

/**
 * / https://github.com/ipfs/kubo/blob/master/docs/config.md#apiauthorizations
 *
 * @generated from message dxos.config.Runtime.Kube.KuboApiAuthorization
 */
export type Runtime_Kube_KuboApiAuthorization = Message<"dxos.config.Runtime.Kube.KuboApiAuthorization"> & {
  /**
   * / Just for organizational purposes.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string auth_secret = 2;
   */
  authSecret: string;

  /**
   * @generated from field: repeated string allowed_paths = 3;
   */
  allowedPaths: string[];
};

/**
 * Describes the message dxos.config.Runtime.Kube.KuboApiAuthorization.
 * Use `create(Runtime_Kube_KuboApiAuthorizationSchema)` to create a new message.
 */
export const Runtime_Kube_KuboApiAuthorizationSchema: GenMessage<Runtime_Kube_KuboApiAuthorization> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 6, 9);

/**
 *
 * DXOS Services.
 *
 *
 * @generated from message dxos.config.Runtime.Services
 */
export type Runtime_Services = Message<"dxos.config.Runtime.Services"> & {
  /**
   * * Deprecated: legacy KUBE deployment descriptor; no runtime readers. 
   *
   * @generated from field: optional dxos.config.Runtime.Services.Kube kube = 1 [deprecated = true];
   * @deprecated
   */
  kube?: Runtime_Services_Kube;

  /**
   * * Deprecated: no runtime readers. 
   *
   * @generated from field: optional dxos.config.Runtime.Services.AppServer app = 2 [deprecated = true];
   * @deprecated
   */
  app?: Runtime_Services_AppServer;

  /**
   * * Deprecated: DXNS removed; no runtime readers. 
   *
   * @generated from field: optional dxos.config.Runtime.Services.Dxns dxns = 3 [deprecated = true];
   * @deprecated
   */
  dxns?: Runtime_Services_Dxns;

  /**
   * @generated from field: optional dxos.config.Runtime.Services.Ipfs ipfs = 4;
   */
  ipfs?: Runtime_Services_Ipfs;

  /**
   * @generated from field: repeated dxos.config.Runtime.Services.Signal signaling = 5;
   */
  signaling: Runtime_Services_Signal[];

  /**
   * @generated from field: repeated dxos.config.Runtime.Services.Ice ice = 6;
   */
  ice: Runtime_Services_Ice[];

  /**
   * @generated from field: repeated dxos.config.Runtime.Services.IceProvider ice_providers = 14;
   */
  iceProviders: Runtime_Services_IceProvider[];

  /**
   * * Deprecated: no runtime readers. 
   *
   * @generated from field: optional dxos.config.Runtime.Services.Machine machine = 7 [deprecated = true];
   * @deprecated
   */
  machine?: Runtime_Services_Machine;

  /**
   * * Deprecated: no runtime readers. 
   *
   * @generated from field: optional dxos.config.Runtime.Services.BotHost bot = 8 [deprecated = true];
   * @deprecated
   */
  bot?: Runtime_Services_BotHost;

  /**
   * * Deprecated: no runtime readers. 
   *
   * @generated from field: optional dxos.config.Runtime.Services.Publisher publisher = 9 [deprecated = true];
   * @deprecated
   */
  publisher?: Runtime_Services_Publisher;

  /**
   * * Deprecated 
   *
   * @generated from field: optional dxos.config.Runtime.Services.Supervisor supervisor = 10 [deprecated = true];
   * @deprecated
   */
  supervisor?: Runtime_Services_Supervisor;

  /**
   * * Deprecated 
   *
   * @generated from field: optional dxos.config.Runtime.Services.Tunneling tunneling = 11 [deprecated = true];
   * @deprecated
   */
  tunneling?: Runtime_Services_Tunneling;

  /**
   * * Deprecated 
   *
   * @generated from field: optional dxos.config.Runtime.Services.Faasd faasd = 12 [deprecated = true];
   * @deprecated
   */
  faasd?: Runtime_Services_Faasd;

  /**
   * / Still read by AgentHostingProvider; retained despite legacy status.
   *
   * @generated from field: optional dxos.config.Runtime.Services.AgentHosting agent_hosting = 13;
   */
  agentHosting?: Runtime_Services_AgentHosting;

  /**
   * @generated from field: optional dxos.config.Runtime.Services.Edge edge = 15;
   */
  edge?: Runtime_Services_Edge;

  /**
   * @generated from field: optional dxos.config.Runtime.Services.Ai ai = 16;
   */
  ai?: Runtime_Services_Ai;

  /**
   * @generated from field: optional dxos.config.Runtime.Services.Hub hub = 17;
   */
  hub?: Runtime_Services_Hub;

  /**
   * @generated from field: optional dxos.config.Runtime.Services.Sandbox sandbox = 18;
   */
  sandbox?: Runtime_Services_Sandbox;

  /**
   * / EDGE service configurations keyed by `EdgeService.name`. The canonical set
   * / of valid names is the `EdgeServiceName` enum in
   * / packages/sdk/config/src/edge-services.ts (e.g. "calls", "image", "discord").
   * / Supersedes per-service URL constants; see packages/sdk/config/AUDIT.md.
   *
   * @generated from field: repeated dxos.config.Runtime.Services.EdgeService edge_services = 19;
   */
  edgeServices: Runtime_Services_EdgeService[];
};

/**
 * Describes the message dxos.config.Runtime.Services.
 * Use `create(Runtime_ServicesSchema)` to create a new message.
 */
export const Runtime_ServicesSchema: GenMessage<Runtime_Services> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7);

/**
 * @generated from message dxos.config.Runtime.Services.Kube
 */
export type Runtime_Services_Kube = Message<"dxos.config.Runtime.Services.Kube"> & {
  /**
   * @generated from field: optional dxos.config.Runtime.Services.Kube.Endpoints endpoints = 1;
   */
  endpoints?: Runtime_Services_Kube_Endpoints;

  /**
   * @generated from field: optional string public_url = 2;
   */
  publicUrl?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Kube.
 * Use `create(Runtime_Services_KubeSchema)` to create a new message.
 */
export const Runtime_Services_KubeSchema: GenMessage<Runtime_Services_Kube> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 0);

/**
 * @generated from message dxos.config.Runtime.Services.Kube.Endpoints
 */
export type Runtime_Services_Kube_Endpoints = Message<"dxos.config.Runtime.Services.Kube.Endpoints"> & {
  /**
   * @generated from field: optional string logs = 1;
   */
  logs?: string;

  /**
   * @generated from field: optional string services = 2;
   */
  services?: string;

  /**
   * @generated from field: optional string cert = 3;
   */
  cert?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Kube.Endpoints.
 * Use `create(Runtime_Services_Kube_EndpointsSchema)` to create a new message.
 */
export const Runtime_Services_Kube_EndpointsSchema: GenMessage<Runtime_Services_Kube_Endpoints> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 0, 0);

/**
 * @generated from message dxos.config.Runtime.Services.AppServer
 */
export type Runtime_Services_AppServer = Message<"dxos.config.Runtime.Services.AppServer"> & {
  /**
   * @generated from field: optional string prefix = 1;
   */
  prefix?: string;

  /**
   * @generated from field: optional string server = 2;
   */
  server?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.AppServer.
 * Use `create(Runtime_Services_AppServerSchema)` to create a new message.
 */
export const Runtime_Services_AppServerSchema: GenMessage<Runtime_Services_AppServer> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 1);

/**
 * TODO(burdon): Delete/Rename DMG.
 *
 * @generated from message dxos.config.Runtime.Services.Dxns
 */
export type Runtime_Services_Dxns = Message<"dxos.config.Runtime.Services.Dxns"> & {
  /**
   * / DXNS endpoint.
   *
   * @generated from field: optional string server = 1;
   */
  server?: string;

  /**
   * *
   * Substrate account URI. This is a secret.
   * KUBEs do not serve this with the config but we store it in profile.yml.
   *
   * TODO(dmaretskyi): Deprecate this and move it to keyring.
   *
   * @generated from field: optional string account_uri = 2;
   */
  accountUri?: string;

  /**
   * *
   * Public Polkadot Address.
   *
   * @generated from field: optional string address = 3;
   */
  address?: string;

  /**
   * *
   * Public address of a DXNS Account.
   *
   * @generated from field: optional string account = 4;
   */
  account?: string;

  /**
   * @generated from field: optional string faucet = 5;
   */
  faucet?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Dxns.
 * Use `create(Runtime_Services_DxnsSchema)` to create a new message.
 */
export const Runtime_Services_DxnsSchema: GenMessage<Runtime_Services_Dxns> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 2);

/**
 * @generated from message dxos.config.Runtime.Services.Ipfs
 */
export type Runtime_Services_Ipfs = Message<"dxos.config.Runtime.Services.Ipfs"> & {
  /**
   * @generated from field: optional string server = 1;
   */
  server?: string;

  /**
   * @generated from field: optional string gateway = 2;
   */
  gateway?: string;

  /**
   * / Used for IPFS API authentication, regardless if server is direct KUBO
   * / API (e.g. path of '/api/v0') or a reverse proxy Same secret format as
   * / https://github.com/ipfs/kubo/blob/master/docs/config.md#apiauthorizations
   *
   * @generated from field: optional string server_auth_secret = 3;
   */
  serverAuthSecret?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Ipfs.
 * Use `create(Runtime_Services_IpfsSchema)` to create a new message.
 */
export const Runtime_Services_IpfsSchema: GenMessage<Runtime_Services_Ipfs> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 3);

/**
 * @generated from message dxos.config.Runtime.Services.Signal
 */
export type Runtime_Services_Signal = Message<"dxos.config.Runtime.Services.Signal"> & {
  /**
   * @generated from field: string server = 1;
   */
  server: string;

  /**
   * @generated from field: optional string api = 2;
   */
  api?: string;

  /**
   * @generated from field: optional string status = 3;
   */
  status?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Signal.
 * Use `create(Runtime_Services_SignalSchema)` to create a new message.
 */
export const Runtime_Services_SignalSchema: GenMessage<Runtime_Services_Signal> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 4);

/**
 * @generated from message dxos.config.Runtime.Services.Ice
 */
export type Runtime_Services_Ice = Message<"dxos.config.Runtime.Services.Ice"> & {
  /**
   * @generated from field: string urls = 1;
   */
  urls: string;

  /**
   * @generated from field: optional string username = 2;
   */
  username?: string;

  /**
   * @generated from field: optional string credential = 3;
   */
  credential?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Ice.
 * Use `create(Runtime_Services_IceSchema)` to create a new message.
 */
export const Runtime_Services_IceSchema: GenMessage<Runtime_Services_Ice> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 5);

/**
 * @generated from message dxos.config.Runtime.Services.IceProvider
 */
export type Runtime_Services_IceProvider = Message<"dxos.config.Runtime.Services.IceProvider"> & {
  /**
   * @generated from field: string urls = 1;
   */
  urls: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.IceProvider.
 * Use `create(Runtime_Services_IceProviderSchema)` to create a new message.
 */
export const Runtime_Services_IceProviderSchema: GenMessage<Runtime_Services_IceProvider> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 6);

/**
 * @generated from message dxos.config.Runtime.Services.Machine
 */
export type Runtime_Services_Machine = Message<"dxos.config.Runtime.Services.Machine"> & {
  /**
   * @generated from field: optional string do_access_token = 1;
   */
  doAccessToken?: string;

  /**
   * @generated from field: optional string github_access_token = 2;
   */
  githubAccessToken?: string;

  /**
   * @generated from field: optional string github_username = 3;
   */
  githubUsername?: string;

  /**
   * @generated from field: optional string dns_domain = 4;
   */
  dnsDomain?: string;

  /**
   * @generated from field: optional string npm_access_token = 5;
   */
  npmAccessToken?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Machine.
 * Use `create(Runtime_Services_MachineSchema)` to create a new message.
 */
export const Runtime_Services_MachineSchema: GenMessage<Runtime_Services_Machine> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 7);

/**
 * TODO(burdon): Add Service suffix to all?
 *
 * @generated from message dxos.config.Runtime.Services.BotHost
 */
export type Runtime_Services_BotHost = Message<"dxos.config.Runtime.Services.BotHost"> & {
  /**
   * @generated from field: optional string proxy = 1;
   */
  proxy?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.BotHost.
 * Use `create(Runtime_Services_BotHostSchema)` to create a new message.
 */
export const Runtime_Services_BotHostSchema: GenMessage<Runtime_Services_BotHost> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 8);

/**
 * TODO(burdon): Publishing.
 *
 * @generated from message dxos.config.Runtime.Services.Publisher
 */
export type Runtime_Services_Publisher = Message<"dxos.config.Runtime.Services.Publisher"> & {
  /**
   * @generated from field: optional string server = 1;
   */
  server?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Publisher.
 * Use `create(Runtime_Services_PublisherSchema)` to create a new message.
 */
export const Runtime_Services_PublisherSchema: GenMessage<Runtime_Services_Publisher> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 9);

/**
 * @generated from message dxos.config.Runtime.Services.Tunneling
 */
export type Runtime_Services_Tunneling = Message<"dxos.config.Runtime.Services.Tunneling"> & {
  /**
   * @generated from field: optional string server = 1;
   */
  server?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Tunneling.
 * Use `create(Runtime_Services_TunnelingSchema)` to create a new message.
 */
export const Runtime_Services_TunnelingSchema: GenMessage<Runtime_Services_Tunneling> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 10);

/**
 * TODO(burdon): Is this a service?
 *
 * @generated from message dxos.config.Runtime.Services.Supervisor
 */
export type Runtime_Services_Supervisor = Message<"dxos.config.Runtime.Services.Supervisor"> & {
  /**
   * @generated from field: optional string server = 1;
   */
  server?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Supervisor.
 * Use `create(Runtime_Services_SupervisorSchema)` to create a new message.
 */
export const Runtime_Services_SupervisorSchema: GenMessage<Runtime_Services_Supervisor> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 11);

/**
 * @generated from message dxos.config.Runtime.Services.Faasd
 */
export type Runtime_Services_Faasd = Message<"dxos.config.Runtime.Services.Faasd"> & {
  /**
   * @generated from field: optional string gateway = 1;
   */
  gateway?: string;

  /**
   * @generated from field: optional string username = 2;
   */
  username?: string;

  /**
   * @generated from field: optional string password = 3;
   */
  password?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Faasd.
 * Use `create(Runtime_Services_FaasdSchema)` to create a new message.
 */
export const Runtime_Services_FaasdSchema: GenMessage<Runtime_Services_Faasd> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 12);

/**
 * TODO(nf): Set API version, authentication scheme, etc.
 *
 * @generated from message dxos.config.Runtime.Services.AgentHosting
 */
export type Runtime_Services_AgentHosting = Message<"dxos.config.Runtime.Services.AgentHosting"> & {
  /**
   * TODO(nf): read enum from yml?
   *
   * @generated from field: optional string server = 1;
   */
  server?: string;

  /**
   * @generated from field: optional string type = 2;
   */
  type?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.AgentHosting.
 * Use `create(Runtime_Services_AgentHostingSchema)` to create a new message.
 */
export const Runtime_Services_AgentHostingSchema: GenMessage<Runtime_Services_AgentHosting> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 13);

/**
 * @generated from message dxos.config.Runtime.Services.Edge
 */
export type Runtime_Services_Edge = Message<"dxos.config.Runtime.Services.Edge"> & {
  /**
   * @generated from field: optional string url = 1;
   */
  url?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Edge.
 * Use `create(Runtime_Services_EdgeSchema)` to create a new message.
 */
export const Runtime_Services_EdgeSchema: GenMessage<Runtime_Services_Edge> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 14);

/**
 * @generated from message dxos.config.Runtime.Services.Ai
 */
export type Runtime_Services_Ai = Message<"dxos.config.Runtime.Services.Ai"> & {
  /**
   * @generated from field: optional string server = 1;
   */
  server?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Ai.
 * Use `create(Runtime_Services_AiSchema)` to create a new message.
 */
export const Runtime_Services_AiSchema: GenMessage<Runtime_Services_Ai> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 15);

/**
 * @generated from message dxos.config.Runtime.Services.Hub
 */
export type Runtime_Services_Hub = Message<"dxos.config.Runtime.Services.Hub"> & {
  /**
   * @generated from field: optional string url = 1;
   */
  url?: string;

  /**
   * / Origin serving the passkey prompt. Must be covered by the WebAuthn relying party the
   * / credential was registered against; the API host is not.
   *
   * @generated from field: optional string auth_url = 2;
   */
  authUrl?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Hub.
 * Use `create(Runtime_Services_HubSchema)` to create a new message.
 */
export const Runtime_Services_HubSchema: GenMessage<Runtime_Services_Hub> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 16);

/**
 * / Canonical descriptor for an EDGE (Cloudflare Worker) service.
 * / Entries in `Services.edge_services` consolidate the per-service URL
 * / constants previously hard-coded in consuming plugins.
 * / NOTE: Modeled as a keyed list rather than a proto `map` because the
 * / effect-proto schema layer does not support map fields.
 *
 * @generated from message dxos.config.Runtime.Services.EdgeService
 */
export type Runtime_Services_EdgeService = Message<"dxos.config.Runtime.Services.EdgeService"> & {
  /**
   * / Canonical service name (e.g. "calls", "image", "transcription"). Unique within `edge_services`.
   *
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * / Service endpoint (http(s)/ws(s) URL).
   *
   * @generated from field: optional string endpoint = 2;
   */
  endpoint?: string;

  /**
   * / Optional service-specific properties (e.g. provider path, auth scheme, region).
   *
   * @generated from field: optional google.protobuf.Struct props = 3;
   */
  props?: JsonObject;
};

/**
 * Describes the message dxos.config.Runtime.Services.EdgeService.
 * Use `create(Runtime_Services_EdgeServiceSchema)` to create a new message.
 */
export const Runtime_Services_EdgeServiceSchema: GenMessage<Runtime_Services_EdgeService> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 17);

/**
 * * Standalone sandbox-service worker origin (API mounted at /api/sandbox). 
 *
 * @generated from message dxos.config.Runtime.Services.Sandbox
 */
export type Runtime_Services_Sandbox = Message<"dxos.config.Runtime.Services.Sandbox"> & {
  /**
   * @generated from field: optional string url = 1;
   */
  url?: string;
};

/**
 * Describes the message dxos.config.Runtime.Services.Sandbox.
 * Use `create(Runtime_Services_SandboxSchema)` to create a new message.
 */
export const Runtime_Services_SandboxSchema: GenMessage<Runtime_Services_Sandbox> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 7, 18);

/**
 * @generated from message dxos.config.Runtime.Keys
 */
export type Runtime_Keys = Message<"dxos.config.Runtime.Keys"> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string value = 2;
   */
  value?: string;
};

/**
 * Describes the message dxos.config.Runtime.Keys.
 * Use `create(Runtime_KeysSchema)` to create a new message.
 */
export const Runtime_KeysSchema: GenMessage<Runtime_Keys> = /*@__PURE__*/
  messageDesc(file_dxos_config, 4, 8);

/**
 * @generated from extension: optional string env_var = 1000;
 */
export const env_var: GenExtension<FieldOptions, string> = /*@__PURE__*/
  extDesc(file_dxos_config, 0);

